/**
 * The two facts the privacy and terms pages need from outside their own text.
 *
 * `CONTACT` is the operator's own mailbox rather than one on the service's
 * domain: a privacy notice that names an address nobody reads is worse than one
 * that names none, and this one already exists. In one place so both pages, and
 * any later page, cannot disagree.
 */
export const CONTACT = "mail@anber.dev";

/** Shown at the foot of both pages. Update it when the text changes, not before. */
export const LAST_UPDATED = "21 August 2026";
